import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import {Link} from "react-router-dom";

const RulesPage: React.FC = () => {

    return(
        <>
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '80vh',
                }}
            >
                <Box sx={{ maxWidth: 800, margin: '0 auto', padding: 2 }}>
                    <Typography variant="h2" gutterBottom>
                        Правила
                    </Typography>

                    <Typography variant="body1">
                        Размер команды - до 5 человек.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Разрешается в команду набирать абсолютно кого угодно - хоть маркетологов, хоть фронтендеров, хоть в одного всё делать.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Как сформируете команды - капитаны команд регистрируют у меня тему проекта - она может быть какая угодно - главное чтобы там использовалась работа с данными в любом виде: или инженерия данных, или аналитика данных. А скорее всего и то и то.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Хаккатон проводится онлайн: сначала команды несколько месяцев работают над своими проектами, потом в районе майских праздников проводят демо того, что получилось.
                    </Typography>

                    <Typography variant="body1">
                        Цель хаккатона: научиться зарабатывать не в найме, используя для этого работу с данными.
                    </Typography>

                    <Typography variant="body1">
                        Поэтому важно будет не только разработать продукт, но и попробовать его продать по различным каналам продаж.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Рекомендую не использовать платную рекламу - т.к. она сейчас слишком дорогая, а если ваш проект будет нужен людям - то клиента вы сможете найти и на форумах или в личной переписке.
                    </Typography>

                    <div>
                        <Typography variant="body1">
                            До заявки проекта рекомендую провести подготовительную работу:
                        </Typography>
                            <ul>
                                <li>Понять, как выглядят ваши клиенты.</li>
                                <li>Провести исследование, какие именно услуги по работе с данными им нужны.</li>
                                <li>Опросить людей, готовы ли они за это платить (9 из 10 потом сольются).</li>
                            </ul>
                    </div>


                    <Typography variant="body1" paragraph>
                        Будут 2 номинации: <Link to="/product">ПРОДУКТ</Link> и <Link to="/service">УСЛУГА</Link> - подробнее смотрите по ссылке.
                    </Typography>
                </Box>
            </Box>
        </>
    )
}

export default RulesPage;